import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import styles from './I18n.module.css';
import { Context } from '../LocaleWrapper';

const I18n = ({ path, args = [], className }) => {
  const { i18n } = React.useContext(Context);
  const value = i18n(path, ...args);
  const debug = i18n('debug');

  if (debug) {
    return (
      <span className={clsx(className, styles.i18n)}>
        {value}
        <span className={styles.path}>{path}</span>
      </span>
    );
  }
  return <span className={clsx(className, styles.i18n)}>{value}</span>;
};

I18n.propTypes = {
  className: PropTypes.string,
  path: PropTypes.string.isRequired,
  args: PropTypes.array,
};

// A convenience component, that uses a supplied base path.
// Avoids the need clutter components with repeated use of long paths in <I18n>s.
export const BasedI18n = (basePath) => {
  const CurriedI18n = ({ path, ...otherProps }) => (
    <I18n path={`${basePath}.${path}`} {...otherProps} />
  );

  CurriedI18n.propTypes = {
    path: PropTypes.string.isRequired,
  };

  return CurriedI18n;
};

export default I18n;
